import * as React from 'react';
import constants from 'assets/constants';
import i18n from 'i18n';
import { useTranslation } from 'react-i18next';

export const SUPPORTED_LOCALES = ["nl", "fr", "en"];

// Currently active language, normalised to one of the supported locales.
export function currentLocale() {
    const lng = (i18n.resolvedLanguage || i18n.language || "nl").split("-")[0];
    return SUPPORTED_LOCALES.includes(lng) ? lng : "nl";
}

// Builds a backend URL and always appends the active locale as a query arg.
export function apiUrl(path) {
    const sep = path.includes("?") ? "&" : "?";
    return constants["BACKEND"] + path + sep + "locale=" + currentLocale();
}

// Re-renders (and therefore refetches) whenever the language changes.
export function useLocale() {
    const { i18n: instance } = useTranslation();
    return React.useMemo(
        () => currentLocale(),
        [instance.resolvedLanguage, instance.language]
    );
}

export { apiFetch } from "./pow";
